import { render, staticRenderFns } from "./CotherButtons.vue?vue&type=template&id=57d0eba3&scoped=true"
import script from "./CotherButtons.vue?vue&type=script&lang=js"
export * from "./CotherButtons.vue?vue&type=script&lang=js"
import style0 from "./CotherButtons.vue?vue&type=style&index=0&id=57d0eba3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d0eba3",
  null
  
)

export default component.exports